module.exports = __webpack_public_path__ + "static/preview-45de0b13f85361f95a5949c8af94b21e.jpg";